export default {
  tableTent: "Payment Options",
  addPayment: "Apply New Payment Brand",
  downloadTableTent: "Download Data",
  ttips: {
    addPayment:
      "Please log in to the WEB application system to proceed with the additional application for payment brands.※If you are unsure about your login account, please contact the StarPay Help Desk at 03-6555-7777."
  }
};
